module.exports = __webpack_public_path__ + "img/classic_m0.4a4b0a24.png";